import * as fromFaqCategories from './faq-category.reducer';
import * as fromFaq from './faq.reducer';

import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'faq';

export interface FaqCategoriesState {
  categories: fromFaqCategories.FaqCategoriesState;
  faq: fromFaq.FaqState;
}

export const reducers: ActionReducerMap<FaqCategoriesState> = {
  categories: fromFaqCategories.FaqCategoriesReducer,
  faq: fromFaq.FaqReducer,
};

export const getLandingState = createFeatureSelector<FaqCategoriesState>(featureKey);

export const metaReducers: MetaReducer<FaqCategoriesState>[] = !environment.production ? [] : [];
